i18n.LANGUAGES = [{
	id: 'cs',
	lang: 'cs-CZ',
	name: 'Česky',
}, {
	id: 'en',
	lang: 'en-US',
	name: 'English',
}/*, {
	id: 'de',
	lang: 'de',
	name: 'Deutsche',
}*/];

function prepFormat(valPrep, fmt, postProc = v => v) {
	return v => {
		if (v != null) {
			v = valPrep(v);

			return postProc(fmt.format(v));
		}

		return '';
	};
}

/*
 * Keep in sync with be/sheet-worker.js
 */
Formats = ((lang) => ({
	
	time: prepFormat(v => new Date(v * 1000), new Intl.DateTimeFormat(lang, { hour: 'numeric', minute: 'numeric', second: 'numeric' })),
	
	date: prepFormat(v => new Date(v * 1000), new Intl.DateTimeFormat(lang, { year: 'numeric', month: 'numeric', day: 'numeric' })),
	date_utc: prepFormat(v => new Date(v * 1000), new Intl.DateTimeFormat(lang, { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' })),
	datetime: prepFormat(v => new Date(v * 1000), new Intl.DateTimeFormat(lang, { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'})),
	datetime_seconds: prepFormat(v => new Date(v * 1000), new Intl.DateTimeFormat(lang, { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'})),

	date_weekday: prepFormat(v => new Date(v * 1000), new Intl.DateTimeFormat(lang, { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric' })),

	time_short: prepFormat(v => new Date(v * 1000), new Intl.DateTimeFormat(lang, { hour: '2-digit', minute: '2-digit' })),
	time_short_utc: prepFormat(v => new Date(v * 1000), new Intl.DateTimeFormat(lang, { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' })),
	date_day_of_week: prepFormat(v => new Date(v * 1000), new Intl.DateTimeFormat(lang, { weekday: 'long' })),
	
	date_or_datetime: v => {
		if (v == null) {
			return '';
		}

		let vd = new Date(v * 1000);
		if (vd.getHours() == 0 && vd.getMinutes() == 0 && vd.getSeconds() == 0) {
			return Formats.date(v);
		} else {
			return Formats.datetime(v);
		}
	},

	input_date: v => {
		let d = new Date(v * 1000);

		if (lang == 'cs-CZ') {
			return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear();
		} else {
			return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();
		}
	},

	input_datetime: v => {
		let d = new Date(v * 1000);
		let has_time = (d.getHours() + d.getMinutes() + d.getSeconds() + d.getMilliseconds()) > 0;

		function p(number) {
			return number < 10 ? '0' + number : number;
		}

		return Formats.input_date(v) + (has_time ? ' ' + d.getHours() + ':' + p(d.getMinutes()) : '');
	},

	percent: v => {
		if (v == null) {
			return '';
		}
		v = Math.round(v * 100);
		return v + '\u2009%';
	},
	
	size: v => {
		if (v == null) {
			return '';
		}
		let size = v;
		const units = ['B', 'kB', 'MB', 'GB' , 'TB'];
		let i = 0;
		while (units[i] && size > 1024) {
			size /= 1024;
			i++;
		}
		return (Math.round(size * 10) / 10) + ' ' + units[i];
	},

	bool: v => {
		return v ? _('Ano') : _('Ne');
	},

	call_direction: v => {
		return {
			internal: _('Interní'),
			'in': _('Příchozí'),
			'out': _('Odchozí'),
		}[v] || v;
	},

	call_result: v => {
		return {
			connected: _('Spojený'),
			abandoned: _('Opuštěný'),
			rejected: _('Odmítnutý'),
			missed: _('Zmeškaný'),
			busy: _('Obsazený'),
		}[v] || _('Neuskutečněný');
	},
	
	transfer_type: v => {
		return {
			direct: _('Přímý'),
			transfered: _('Přepojený'),
		}[v] || v;
	},
	
	campaign_case_status: v => {
		return {
			'new': _('Nezahájeno'),
			'active': _('Probíhá'),
			'closed': _('Dokončeno'),
		}[v] || v
	},
	
	duration: v => {
		if (v == null) {
			return '';
		}

		let sign = v < 0 ? '-' : '';

		v = Math.floor(Math.abs(v) / 1000);

		return sign + [
			(v / 60 / 60) | 0,
			(v / 60 % 60) | 0,
			(v % 60) | 0,
		]
			.join(":")
			.replace(/\b(\d)\b/g, "0$1");
	},

	duration_unpadded: v => {
		if (v == null) {
			return '';
		}

		let sign = v < 0 ? '-' : '';

		v = Math.floor(Math.abs(v) / 1000);

		let ret = [
			(v / 60 % 60) | 0, // minutes - we're leaving them to be absolutely clear that value is time
			(v % 60) | 0, // seconds
		];

		if (v >= 3600) {
			// add hours only when there are any
			ret = [(v / 60 / 60) | 0, ...ret];
		}

		return sign + ret
			.join(":")
			.replace(/\b(\d)\b/g, "0$1");
	},

	duration_short: v => {
		if (v == null) {
			return '';
		}

		let sign = v < 0 ? '-' : '';

		v = Math.floor(Math.abs(v) / 1000);

		return sign + [
			(v / 60 / 60) | 0,
			(v / 60 % 60) | 0
		]
			.join(":")
			.replace(/\b(\d)\b/g, "0$1");
	},
}))({
	cs: 'cs-CZ',
	en: 'en-US',
	de: 'de',
}[i18n.lang]);

let Uploads = {
	fileSelect(accept) {
		return new Promise((res, rej) => {
			let fileEl = document.gwCreateElement({
				nodeName: 'input',
				type: 'file',
				accept,
				capture: 'environment',
				'style:display': 'none',
				'on:change': ev => {
					res(fileEl.files[0]);
					fileEl.remove();
				}
			});

			// iOS Safari requires file input to be in the DOM
			document.body.appendChild(fileEl);
			fileEl.click();
		});
	},

	uploadFile(path, file, {signal, progress, headers} = {}) {
		return new Promise((res, rej) => {
			let xhr = new XMLHttpRequest();

			if (signal instanceof AbortSignal) {
				signal.onabort = () => {
					rej(new AbortError);
					xhr.abort();
				};
			}

			xhr.open('POST', API_BASE + path, true);
			xhr.timeout = 60 * 60 * 1000; // 1 hour
			xhr.responseType = 'json';
			xhr.setRequestHeader('X-Anti-CSRF', '1');
			xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
			for (let [k, v] of Object.entries(headers || {})) {
				xhr.setRequestHeader(k, v);
			}

			xhr.onabort = ev => {
				rej(new AbortError);
			};

			xhr.ontimeout = ev => {
				rej(new Error(_('Nahrání selhalo - vypršel časový limit')))
			};

			xhr.onerror = ev => {
				rej(new Error(_('Nahrání selhalo - neznámá chyba')))
			};

			xhr.upload.onprogress = ev => {
				if (ev.lengthComputable) {
					progress && progress(ev);
				}
			};

			xhr.onload = ev => {
				if (xhr.status >= 200 && xhr.status < 300) {
					res(xhr.response);
				} else {
					let err = new Error(xhr.response ? xhr.response.error : _('Neznámá chyba'));
					err.xhr = xhr;
					rej(err);
				}
			};

			xhr.send(file);
		});
	},
};

let Export = {
	async xlsx(config, {signal} = {}) {
		try {
			let res = await fetch(API_BASE + 'export/xlsx', {
				method: 'POST',
				mode: 'same-origin',
				headers: {
					'Content-Type': 'application/json;charset=utf-8',
					'X-Anti-CSRF': '1',
				},
				body: JSON.stringify(config),
				cache: 'default',
				signal,
			});

			if (res.ok) {
				let blob = new File([await res.blob()], config.filename);
				let file = URL.createObjectURL(blob);

				const a = document.createElement("a");
				a.href = file;
				a.download = config.filename;
				a.click();
				window.URL.revokeObjectURL(file);
			} else {
				let errData = {};
				try {
					errData = await res.json();
				} catch (ex) {}

				let err = new RESTError((errData || {}).error || `XLSX export failed with status: ${res.status}`);
				err.status = res.status;
				throw err;
			}
		} catch (ex) {
			if (ex instanceof DOMException) {
				throw new AbortError();
			}

			throw ex;
		}
	},
};

let Charts = (() => {
	// callbacks to run on library load
	let libraryOnLoad = [];
	
	function loadLibrary() {
		if (typeof Chart !== 'undefined') {
			// already loaded or loading
			return;
		}

		document.head.gwCreateChild({
			nodeName: 'script',
			'on:load': ev => {
				if (typeof Chart === 'function') {
					for (let callback of libraryOnLoad) {
						callback();
					} 
				} else {
					console.error('No Chart object available after loading chart library. Charts will not be drawn');
				}

				libraryOnLoad = null;
			},
			'on:error': ev => {
				console.warn("Could not load chart library", e);

				libraryOnLoad = null;
			},
			src: '/vendor/chart-3.8.0.min.js',
		});

		Chart = true; // set Chart to avoid parallel loading
	}
	
	function runOnLoaded(cb) {
		loadLibrary();

		if (typeof Chart == 'function') {
			// chart library loaded, run callback directly
			cb();
		} else if (libraryOnLoad) {
			libraryOnLoad.push(cb);
		}
	}

	/**
	 * Chart JS plugin to draw rounded ends of arcs in doughnut chart
	 * inspired by answers at https://stackoverflow.com/questions/37384092/chart-js-doughnut-with-rounded-edges-and-text-centered
	 */
	const roundedDoughnutPlugin = {
		afterDraw: chart => {
			if (chart.options.doughnutRoundedCorners === undefined) {
				return;
			}
			let {ctx} = chart;
			let roundedCornersFor = chart.options.doughnutRoundedCorners;
			for (let position in roundedCornersFor) {
				const values = Array.isArray(roundedCornersFor[position]) ? roundedCornersFor[position] : [roundedCornersFor[position]];
				values.forEach(p => {
					const arc = chart.getDatasetMeta(0).data[p];
					const radius = (arc.outerRadius + arc.innerRadius) / 2;
					const thickness = (arc.outerRadius - arc.innerRadius - arc.options.borderWidth) / 2;
					const startAngle = Math.PI / 2 - arc.startAngle;
					const endAngle = Math.PI / 2 - arc.endAngle;
					ctx.save();
					ctx.translate(arc.x, arc.y);
					ctx.fillStyle = arc.options.backgroundColor;
					ctx.beginPath();
					if (position === "start") {
						ctx.arc(radius * Math.sin(startAngle), radius * Math.cos(startAngle), thickness, 0, 2 * Math.PI);
					} else {
						ctx.arc(radius * Math.sin(endAngle), radius * Math.cos(endAngle), thickness, 0, 2 * Math.PI);
					}
					ctx.closePath();
					ctx.fill();
					ctx.restore();
				});

			}
		}
	};

	function makeChart(el, label, config, size) {
		el.dataset.format = config.type; // for CSS styling

		let canvas = el.gwCreateChild({
			nodeName: 'canvas',
			style: 'display: inline-block',
			width: (size ? size.width : size) || 34,
			height: (size ? size.height : size) || 34,
		});

		if (label) {
			let labelContent = {
				nodeName: 'span',
			}
			if (Array.isArray(label)) {
				labelContent.children = label;
			} else {
				labelContent.textContent = label;
			}
			
			el.gwCreateChild(labelContent);
		}
		
		config.plugins = [roundedDoughnutPlugin];

		runOnLoaded(() => new Chart(canvas.getContext('2d'), config));
	}
	
	return {
		/*
		 * make doughnut chart, independent on used library
		 * - el
		 * - groups: doughnut graph groups
		 *   - label
		 *   - color
		 *   - value
		 * - label
		 * - size: number | {width: number, height: number}
		 * - options: additional options for library config
		 */
		makeDoughnut(el, groups, label, size, options) {
			let colors = groups.map(g => Utils.resolveCSSVar(g.color));
			let labels = groups.map(g => g.label);

			makeChart(el, label, {
				type: 'doughnut',
				data: {
					labels,
					datasets: [{
						data: groups.map(g => g.value),
					}],
				},
				options: {
					responsive: false,
					maintainAspectRatio: false,
					animation: false,
					backgroundColor: colors,
					cutout: '42%',
					borderWidth: 1,
					borderColor: Utils.getStyleRootProperty('--graph-border-color'),
					events: [],
					plugins: {
						legend: {display: false},
						tooltip: {enabled: false}
					},
					...(options || {})
				},
			}, size);
		},
	}
})();

Object.defineProperty(Array.prototype, 'insertBetweenAll', {
	value: function(...val) {
		let out = [];

		for (let i = 0; i < this.length; i++) {
			if (i != 0) {
				out.push(...val);
			}

			out.push(this[i]);
		}

		return out;
	},
	enumerable: false,
	writable: false,
});

function get_international_number(num) {
	if (num == null) {
		return null;
	}

	if (String(num).match(/^[0-9]{9}$/)) {
		return '+420' + num;
	}

	return num;
}

function phone_number_equal(a, b) {
	return get_international_number(a) == get_international_number(b);
}
